// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Color definitions for the app
 */

.LocationCard .card-container:focus {
  outline: none;
}
.LocationCard .card-container .location-data {
  width: 100%;
}
.LocationCard .card-container .location-image-container {
  position: relative;
}
.LocationCard .card-container .location-image-container .location-details {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  background-color: rgba(96, 86, 124, 0.5019607843);
}
.LocationCard .card-container .location-image-container .location-details .details-link {
  display: inline-block;
  margin-top: 20px;
}
.LocationCard .card-container .location-image-container .location-details .details-link .details-button {
  border-color: #333F48;
  background-color: #FFFFFF;
  font-family: "Lato", sans-serif;
  font-size: 12px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.48;
  letter-spacing: 0.8px;
  color: #333F48;
  text-transform: uppercase;
}
.LocationCard .card-container:hover .location-details {
  display: block;
}
.LocationCard .card-container .name-container {
  display: flex;
  align-items: center;
  margin: 16px 16px 8px 16px;
}
.LocationCard .card-container .name-container .location-name {
  min-width: 50%;
  padding-right: 24px;
  font-size: 14px;
  font-weight: 900;
  letter-spacing: normal;
}
.LocationCard .card-container .name-container .location-status {
  width: 8px;
  min-width: 8px;
  height: 8px;
  margin-right: 8px;
  fill-opacity: 0.8;
  border-radius: 50%;
}
.LocationCard .card-container .name-container .location-status-online {
  background: rgba(0, 164, 116, 0.75);
  border: 2px solid #00A474;
}
.LocationCard .card-container .name-container .location-status-transit {
  background: rgba(246, 103, 51, 0.75);
  border: 2px solid #F66733;
}
.LocationCard .card-container .name-container .location-status-offline {
  background: rgba(207, 8, 56, 0.75);
  border: 2px solid #CF0838;
}
.LocationCard .card-container .location-image {
  width: 100%;
  height: 100px;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
  object-fit: cover;
}
.LocationCard .card-container .location-name,
.LocationCard .card-container .location-company,
.LocationCard .card-container .location {
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.LocationCard .card-container .location-company {
  font-family: "Lato", sans-serif;
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #383838;
}
.LocationCard .card-container .location {
  font-family: "Lato", sans-serif;
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #383838;
}
.LocationCard .card-container .company-logo {
  min-width: 32px;
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 50%;
  margin-right: 8px;
}
.LocationCard .card-container .company-container {
  display: flex;
  align-items: center;
  margin: 0 16px;
  margin-bottom: 10px;
}
.LocationCard .card-container .company-container .company-and-address {
  min-width: 50%;
}
.LocationCard .arrow {
  height: 16px;
  width: 16px;
  margin-left: 8px;
}`, "",{"version":3,"sources":["webpack://./src/vibeguide/src/sass/color.scss","webpack://./src/vibeguide/src/components/LocationCard/LocationCard.scss"],"names":[],"mappings":"AAAA;;EAAA;;ACMI;EACE,aAAA;AAmFN;AAhFI;EACE,WAAA;AAkFN;AA/EI;EACE,kBAAA;AAiFN;AA/EM;EACE,aAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iDAAA;AAiFR;AA/EQ;EACE,qBAAA;EACA,gBAAA;AAiFV;AA/EU;EACE,qBD3BF;EC4BE,yBDXJ;ECYI,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,qBAAA;EACA,cDpCF;ECqCE,yBAAA;AAiFZ;AAzEM;EACE,cAAA;AA2ER;AAvEI;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;AAyEN;AAvEM;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAyER;AAtEM;EACE,UAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAwER;AArEM;EACE,mCDTI;ECUJ,yBAAA;AAuER;AApEM;EACE,oCDrBG;ECsBH,yBAAA;AAsER;AAnEM;EACE,kCDbE;ECcF,yBAAA;AAqER;AAjEI;EACE,WAAA;EACA,aAAA;EACA,4BAAA;EACA,2BAAA;EACA,iBAAA;AAmEN;AAhEI;;;EAGE,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAkEN;AA/DI;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cDxGK;ACyKX;AA9DI;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cDnHK;ACmLX;AA7DI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AA+DN;AA5DI;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AA8DN;AA5DM;EACE,cAAA;AA8DR;AAzDE;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AA2DJ","sourcesContent":["/**\n * Color definitions for the app\n */\n\n// Theme Colors\n$primary: #333F48;\n$secondary: #222732;\n$yellow: #FECF0C;\n$red: #E02D4F;\n$teal: #23CCC3;\n$orange: #F66733;\n$lightGray: #F6F6F6;\n$whiteSmoke: #E1E1E9;\n$manatee: #959AAD;\n$obsidian: #383838;\n\n// Status Colors\n$success: #00A474;\n$warning: #FFC107;\n$error: #CF0838;\n\n// Other Colors\n$white: #FFFFFF;\n$black: #000000;\n$gray: #757575;\n$darkGray: #A4A7B7;\n$mediumGray: #E0E0E0;\n$lighterGray: #E3E7F4;\n$lightSlateGray: #8A8FA3;\n$carrot: #FF892E;\n$lightSmoke: #F5F4F5;\n$graphBlue: #1570EF;\n$lightOrchid: #7F56D9;\n$rainboots: #3361E1;\n$royalBlue: #4085DE;\n$sushi: #95C653;\n\n// Component Colors\n$primaryButtonBackground: $yellow;\n$primaryButtonText: $primary;\n$secondaryButtonBackground: $primary;\n$secondaryButtonText: $white;\n$navigationText: #95A3AD;\n$scheduleMusic: #FCC7B3;\n$scheduleMessageBlock: $teal;\n$scheduleInterrupt: #1997A3;\n$scheduleLoop: $primary;\n\n// Variants: Theme Colors\n$primary16: rgba($primary, 0.16);\n$primary40: rgba($primary, 0.4);\n$primary50: rgba($primary, 0.5);\n$primary60: rgba($primary, 0.6);\n$secondary25: rgba($secondary, 0.25);\n$secondary50: rgba($secondary, 0.5);\n$secondary75: rgba($secondary, 0.75);\n$yellow16: rgba($yellow, 16%);\n$yellow25: rgba($yellow, 25%);\n$yellow75: rgba($yellow, 75%);\n$orange16: rgba($orange, 0.16);\n$orange32: rgba($orange, 0.32);\n$orange50: rgba($orange, 0.5);\n$orange75: rgba($orange, 0.75);\n$manatee16: rgba($manatee, 0.16);\n$manatee50: rgba($manatee, 0.5);\n\n// Variants: Status Colors\n$success10: rgba($success, 0.08);\n$success16: rgba($success, 0.16);\n$success75: rgba($success, 0.75);\n$warning50: rgba($warning, 0.5);\n$error10: rgba($error, 0.1);\n$error16: rgba($error, 0.16);\n$error20: rgba($error, 0.2);\n$error50: rgba($error, 0.5);\n$error75: rgba($error, 0.75);\n$error85: rgba($error, 0.85);\n\n// Variants: Other Colors\n$gray50: #F9FAFB;\n$gray200: #EAECF0;\n$gray300: #D0D5DD;\n$gray400: #98A2B3;\n$gray500: #667085;\n$gray700: #344054;\n$gray900: #101828;\n$carrot16: rgba($carrot, 0.16);\n$rainboots16: rgba($rainboots, 0.16);\n$royalBlue16: rgba($royalBlue, 0.16);\n\n// Box colors (for color picker)\n$boxRed: $red;\n$boxPink: #F57A7A;\n$boxOrange: $orange;\n$boxYellow: $yellow;\n$boxGreen: #95C653;\n$boxDarkGreen: #00A474;\n$boxBlue: #33ACE1;\n$boxDarkBlue: #3361E1;\n$boxPurple: #6D6DB5;\n$boxDarkPurple: #332A4B;\n\n:export {\n  // Theme Colors\n  primary: $primary;\n  secondary: $secondary;\n  yellow: $yellow;\n  red: $red;\n  teal: $teal;\n  orange: $orange;\n  lightGray: $lightGray;\n  whiteSmoke: $whiteSmoke;\n  manatee: $manatee;\n  obsidian: $obsidian;\n\n  // Status Colors\n  success: $success;\n  warning: $warning;\n  error: $error;\n\n  // Other Colors\n  white: $white;\n  black: $black;\n  gray: $gray;\n  darkGray: $darkGray;\n  mediumGray: $mediumGray;\n  lighterGray: $lighterGray;\n  lightSlateGray: $lightSlateGray;\n  carrot: $carrot;\n  lightSmoke: $lightSmoke;\n  graphBlue: $graphBlue;\n  lightOrchid: $lightOrchid;\n  rainboots: $rainboots;\n  royalBlue: $royalBlue;\n  sushi: $sushi;\n\n  // Component Colors\n  primaryButtonBackground: $primaryButtonBackground;\n  primaryButtonText: $primaryButtonText;\n  secondaryButtonBackground: $secondaryButtonBackground;\n  secondaryButtonText: $secondaryButtonText;\n  navigationText: $navigationText;\n  scheduleMusic: $scheduleMusic;\n  scheduleMessageBlock: $scheduleMessageBlock;\n  scheduleInterrupt: $scheduleInterrupt;\n  scheduleLoop: $scheduleLoop;\n  \n  // Variants: Theme Colors\n  primary16: $primary16;\n  primary40: $primary40;\n  primary50: $primary50;\n  primary60: $primary60;\n  secondary25: $secondary25;\n  secondary50: $secondary50;\n  secondary75: $secondary75;\n  yellow16: $yellow16;\n  yellow25: $yellow25;\n  yellow75: $yellow75;\n  orange16: $orange16;\n  orange32: $orange32;\n  orange50: $orange50;\n  orange75: $orange75;\n  manatee16: $manatee16;\n  manatee50: $manatee50;\n\n  // Variants: Status Colors\n  success10: $success10;\n  success16: $success16;\n  success75: $success75;\n  warning50: $warning50;\n  error10: $error10;\n  error16: $error16;\n  error20: $error20;\n  error50: $error50;\n  error75: $error75;\n  error85: $error85;\n\n  // Variants: Other Colors\n  gray50: $gray50;\n  gray200: $gray200;\n  gray300: $gray300;\n  gray400: $gray400;\n  gray500: $gray500;\n  gray700: $gray700;\n  gray900: $gray900;\n  carrot16: $carrot16;\n  rainboots16: $rainboots16;\n  royalBlue16: $royalBlue16;\n\n  // Box colors (for color picker)\n  boxRed: $boxRed;\n  boxPink: $boxPink;\n  boxOrange: $boxOrange;\n  boxYellow: $boxYellow;\n  boxGreen: $boxGreen;\n  boxDarkGreen: $boxDarkGreen;\n  boxBlue: $boxBlue;\n  boxDarkBlue: $boxDarkBlue;\n  boxPurple: $boxPurple;\n  boxDarkPurple: $boxDarkPurple;\n}\n","@use '../../sass/color.scss' as color;\n\n.LocationCard {\n\n  .card-container {\n\n    &:focus {\n      outline: none;\n    }\n\n    .location-data {\n      width: 100%;\n    }\n\n    .location-image-container {\n      position: relative;\n\n      .location-details {\n        display: none;\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        text-align: center;\n        background-color: #60567c80;\n\n        .details-link {\n          display: inline-block;\n          margin-top: 20px;\n\n          .details-button {\n            border-color: color.$primary;\n            background-color: color.$white;\n            font-family: 'Lato', sans-serif;\n            font-size: 12px;\n            font-weight: 900;\n            font-style: normal;\n            font-stretch: normal;\n            line-height: 1.48;\n            letter-spacing: 0.8px;\n            color: color.$primary;\n            text-transform: uppercase;\n          }\n        }\n      }\n    }\n\n    &:hover {\n\n      .location-details {\n        display: block;\n      }\n    }\n\n    .name-container {\n      display: flex;\n      align-items: center;\n      margin: 16px 16px 8px 16px;\n\n      .location-name {\n        min-width: 50%;\n        padding-right: 24px;\n        font-size: 14px;\n        font-weight: 900;\n        letter-spacing: normal;\n      }\n\n      .location-status {\n        width: 8px;\n        min-width: 8px;\n        height: 8px;\n        margin-right: 8px;\n        fill-opacity: 0.8;\n        border-radius: 50%;\n      }\n\n      .location-status-online {\n        background: color.$success75;\n        border: 2px solid color.$success;\n      }\n\n      .location-status-transit {\n        background: color.$orange75;\n        border: 2px solid color.$orange;\n      }\n\n      .location-status-offline {\n        background: color.$error75;\n        border: 2px solid color.$error;\n      }\n    }\n\n    .location-image {\n      width: 100%;\n      height: 100px;\n      border-top-right-radius: 3px;\n      border-top-left-radius: 3px;\n      object-fit: cover;\n    }\n\n    .location-name,\n    .location-company,\n    .location {\n      flex-grow: 1;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    .location-company {\n      font-family: 'Lato', sans-serif;\n      font-size: 12px;\n      font-weight: 600;\n      font-style: normal;\n      font-stretch: normal;\n      line-height: 1.33;\n      letter-spacing: normal;\n      color: color.$obsidian;\n    }\n\n    .location {\n      font-family: 'Lato', sans-serif;\n      font-size: 12px;\n      font-weight: 300;\n      font-style: normal;\n      font-stretch: normal;\n      line-height: 1.33;\n      letter-spacing: normal;\n      color: color.$obsidian;\n    }\n\n    .company-logo {\n      min-width: 32px;\n      width: 32px;\n      height: 32px;\n      object-fit: cover;\n      border-radius: 50%;\n      margin-right: 8px;\n    }\n\n    .company-container {\n      display: flex;\n      align-items: center;\n      margin: 0 16px;\n      margin-bottom: 10px;\n\n      .company-and-address {\n        min-width: 50%;\n      }\n    }\n  }\n\n  .arrow {\n    height: 16px;\n    width: 16px;\n    margin-left: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export var primary = `#333F48`;
export var secondary = `#222732`;
export var yellow = `#FECF0C`;
export var red = `#E02D4F`;
export var teal = `#23CCC3`;
export var orange = `#F66733`;
export var lightGray = `#F6F6F6`;
export var whiteSmoke = `#E1E1E9`;
export var manatee = `#959AAD`;
export var obsidian = `#383838`;
export var success = `#00A474`;
export var warning = `#FFC107`;
export var error = `#CF0838`;
export var white = `#FFFFFF`;
export var black = `#000000`;
export var gray = `#757575`;
export var darkGray = `#A4A7B7`;
export var mediumGray = `#E0E0E0`;
export var lighterGray = `#E3E7F4`;
export var lightSlateGray = `#8A8FA3`;
export var carrot = `#FF892E`;
export var lightSmoke = `#F5F4F5`;
export var graphBlue = `#1570EF`;
export var lightOrchid = `#7F56D9`;
export var rainboots = `#3361E1`;
export var royalBlue = `#4085DE`;
export var sushi = `#95C653`;
export var primaryButtonBackground = `#FECF0C`;
export var primaryButtonText = `#333F48`;
export var secondaryButtonBackground = `#333F48`;
export var secondaryButtonText = `#FFFFFF`;
export var navigationText = `#95A3AD`;
export var scheduleMusic = `#FCC7B3`;
export var scheduleMessageBlock = `#23CCC3`;
export var scheduleInterrupt = `#1997A3`;
export var scheduleLoop = `#333F48`;
export var primary16 = `rgba(51, 63, 72, 0.16)`;
export var primary40 = `rgba(51, 63, 72, 0.4)`;
export var primary50 = `rgba(51, 63, 72, 0.5)`;
export var primary60 = `rgba(51, 63, 72, 0.6)`;
export var secondary25 = `rgba(34, 39, 50, 0.25)`;
export var secondary50 = `rgba(34, 39, 50, 0.5)`;
export var secondary75 = `rgba(34, 39, 50, 0.75)`;
export var yellow16 = `rgba(254, 207, 12, 0.16)`;
export var yellow25 = `rgba(254, 207, 12, 0.25)`;
export var yellow75 = `rgba(254, 207, 12, 0.75)`;
export var orange16 = `rgba(246, 103, 51, 0.16)`;
export var orange32 = `rgba(246, 103, 51, 0.32)`;
export var orange50 = `rgba(246, 103, 51, 0.5)`;
export var orange75 = `rgba(246, 103, 51, 0.75)`;
export var manatee16 = `rgba(149, 154, 173, 0.16)`;
export var manatee50 = `rgba(149, 154, 173, 0.5)`;
export var success10 = `rgba(0, 164, 116, 0.08)`;
export var success16 = `rgba(0, 164, 116, 0.16)`;
export var success75 = `rgba(0, 164, 116, 0.75)`;
export var warning50 = `rgba(255, 193, 7, 0.5)`;
export var error10 = `rgba(207, 8, 56, 0.1)`;
export var error16 = `rgba(207, 8, 56, 0.16)`;
export var error20 = `rgba(207, 8, 56, 0.2)`;
export var error50 = `rgba(207, 8, 56, 0.5)`;
export var error75 = `rgba(207, 8, 56, 0.75)`;
export var error85 = `rgba(207, 8, 56, 0.85)`;
export var gray50 = `#F9FAFB`;
export var gray200 = `#EAECF0`;
export var gray300 = `#D0D5DD`;
export var gray400 = `#98A2B3`;
export var gray500 = `#667085`;
export var gray700 = `#344054`;
export var gray900 = `#101828`;
export var carrot16 = `rgba(255, 137, 46, 0.16)`;
export var rainboots16 = `rgba(51, 97, 225, 0.16)`;
export var royalBlue16 = `rgba(64, 133, 222, 0.16)`;
export var boxRed = `#E02D4F`;
export var boxPink = `#F57A7A`;
export var boxOrange = `#F66733`;
export var boxYellow = `#FECF0C`;
export var boxGreen = `#95C653`;
export var boxDarkGreen = `#00A474`;
export var boxBlue = `#33ACE1`;
export var boxDarkBlue = `#3361E1`;
export var boxPurple = `#6D6DB5`;
export var boxDarkPurple = `#332A4B`;
export default ___CSS_LOADER_EXPORT___;
